'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SideMenu = require('./core/SideMenu');

var _SideMenu2 = _interopRequireDefault(_SideMenu);

var _Header = require('./core/Header');

var _Header2 = _interopRequireDefault(_Header);

var _navigation = require('./core/navigation');

var _navigation2 = _interopRequireDefault(_navigation);

var _Link = require('./core/navigation/Link');

var _Link2 = _interopRequireDefault(_Link);

var _LinkLayout = require('./core/navigation/LinkLayout');

var _LinkLayout2 = _interopRequireDefault(_LinkLayout);

var _BackLink = require('./core/navigation/BackLink');

var _BackLink2 = _interopRequireDefault(_BackLink);

var _Separator = require('./core/navigation/Separator');

var _Separator2 = _interopRequireDefault(_Separator);

var _Category = require('./core/navigation/Category');

var _Category2 = _interopRequireDefault(_Category);

var _Badge = require('./core/navigation/Badge');

var _Badge2 = _interopRequireDefault(_Badge);

var _Promotion = require('./core/Promotion');

var _Promotion2 = _interopRequireDefault(_Promotion);

var _footer = require('./core/footer');

var _footer2 = _interopRequireDefault(_footer);

var _Link3 = require('./core/footer/Link');

var _Link4 = _interopRequireDefault(_Link3);

var _TinyLink = require('./core/footer/TinyLink');

var _TinyLink2 = _interopRequireDefault(_TinyLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_SideMenu2.default.Logo = _Header2.default;
_SideMenu2.default.Header = _Header2.default;
_SideMenu2.default.Navigation = _navigation2.default;
_SideMenu2.default.NavigationLink = _Link2.default;
_SideMenu2.default.NavigationLinkLayout = _LinkLayout2.default;
_SideMenu2.default.NavigationBackLink = _BackLink2.default;
_SideMenu2.default.NavigationSeparator = _Separator2.default;
_SideMenu2.default.NavigationCategory = _Category2.default;
_SideMenu2.default.NavigationBadge = _Badge2.default;
_SideMenu2.default.Promotion = _Promotion2.default;
_SideMenu2.default.Footer = _footer2.default;
_SideMenu2.default.FooterLink = _Link4.default;
_SideMenu2.default.FooterTinyLink = _TinyLink2.default;

exports.default = _SideMenu2.default;